import React, { useState, useRef, useEffect } from "react";
import { Loader, Dimmer } from "semantic-ui-react";
import axios from "axios";
import { TableBody, TableRow, TableCell } from "@material-ui/core";
import useTableScroll from "../useTableScroll";
import { Mensaje, MensajeSiNo } from "../../components/mensajes";
import {
  formatMoneda,
  validaSoloNumero,
  validaMonto,
  formatoMonto,
  seleccionarCampo,
} from "../../util/varios";
import moment from "moment";
import { TortaMoneda } from "../graficos/graficos";
import { Line } from "react-chartjs-2";
import CatalogoCambiarTasa from "../../catalogos/catalogoCrearTasa";

const GestionarMoneda = () => {
  var op = require("../../../public/modulos/datos");
  let token = sessionStorage.getItem("jwtToken");
  let fechaSistema = JSON.parse(sessionStorage.getItem("fechasistema"));

  const colores = [
    "#17a2b8",
    "#ffae00",
    "#dc3545",
    "#BDB76B",
    "#7B68EE",
    "#4B0082",
    "#00ffff",
    "#0080ff",
    "#0000ff",
    "#8000ff",
    "#ff00ff",
    "#ff0080",
  ];

  const btnCatalogo = useRef();
  const txtCodMoneda = useRef();
  const txtMoneda = useRef();
  const txtLogo = useRef();

  const [body, setBody] = useState(null);
  const [colorG, setColorG] = useState([]);
  const [valor, setValor] = useState([]);
  const [label, setLabel] = useState([]);
  const [tipo, setTipo] = useState([]);
  const [rmoney, setRmoney] = useState([]);
  const [idm, setIdm] = useState(0);
  const [idmonedadeta, setIdmonedadeta] = useState(0);
  const [fecha, setFecha] = useState("");
  const [total, setTotal] = useState(0.0);
  const [menor, setMenor] = useState(0.0);
  const [operacion, setOperacion] = useState(0);
  const [bloqueado, setBloqueado] = useState(true);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [monedas, setMonedas] = useState([]);
  const [info, setInfo] = useState([]);
  const [datos, setDatos] = useState([]);
  const [catalogo, setCatalogo] = useState(false);
  const [botones, setBotones] = useState({
    incluir: false,
    consultar: false,
    modificar: false,
    eliminar: false,
    aceptar: true,
    cancelar: true,
    catalogo: true,
    catalogoper: true,
    tab1: true,
    tab2: true,
  });

  let nomtabla;

  if (operacion === 3) {
    nomtabla = [
      {
        id: "1",
        backgroundColor: "rgba(5, 81, 130, 1)",
        color: "#ffffff",
        label: "FECHA DE REGISTRO",
        textAlign: "center",
      },
      {
        id: "2",
        backgroundColor: "rgba(5, 81, 130, 1)",
        color: "#ffffff",
        label: "TASA",
        textAlign: "center",
      },
      {
        id: "3",
        backgroundColor: "rgba(5, 81, 130, 1)",
        color: "#ffffff",
        label: "-",
        textAlign: "center",
      },
    ];
  } else {
    nomtabla = [
      {
        id: "1",
        backgroundColor: "rgba(5, 81, 130, 1)",
        color: "#ffffff",
        label: "FECHA DE REGISTRO",
        textAlign: "center",
      },
      {
        id: "2",
        backgroundColor: "rgba(5, 81, 130, 1)",
        color: "#ffffff",
        label: "TASA",
        textAlign: "center",
      },
      {
        id: "3",
        backgroundColor: "rgba(5, 81, 130, 1)",
        color: "#ffffff",
        label: "-",
        textAlign: "center",
      },
    ];
  }

  const headCells = nomtabla;

  const { TblContainer, TblHead } = useTableScroll(headCells);

  const seleccionarRegistrosm = (opera) => {
    let campos =
      "idmoneda, trim(descripcion) as descripcion, simbolo, predeterminada, valormoneda";
    let nomtab = "moneda";
    let orden = "idmoneda";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?&campos=${campos}&nomtab=${nomtab}&orden=${orden}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            let datos = [];

            for (let i = 0; i < response.data.length; i++) {
              if (response.data[i].predeterminada !== true) {
                datos.push({
                  idmoneda: response.data[i].idmoneda,
                  descripcion: response.data[i].descripcion,
                  simbolo: response.data[i].simbolo,
                  predeterminada: response.data[i].predeterminada,
                  valormoneda: response.data[i].valormoneda,
                  subpredeterminada: response.data[i].subpredeterminada,
                });
              }
            }

            setRmoney(datos);
            let idmoney = txtCodMoneda.current.value;
            if (opera !== 2) {
              selectDetallesMoneda(idmoney);
            }
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const procesarRegistro = () => {
    setActivate(true);
    let ope = 0;
    if (!botones.incluir) {
      ope = 2;
    } else if (!botones.modificar) {
      ope = 2;
    } else if (!botones.eliminar) {
      ope = 3;
    }
    let endpoint = `${op.conexion}/api/moneda/actualizar/${ope}`;
    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (ope === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "Registro Creado Correctamente",
              icono: "exito",
            });
            seleccionarRegistros();
          } else if (ope === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "Registro Modificado Correctamente",
              icono: "exito",
            });
            seleccionarRegistros();
          } else if (ope === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "Registro Eliminado Correctamente",
              icono: "exito",
            });
            seleccionarRegistros();
          }
          setActivate(false);
        }
      })
      .catch(function (error) {
        let mensaje = "";
        if (error.response === undefined) {
          mensaje = "Error de Conexion";
        } else {
          if (
            error.response.data.message ===
            'duplicate key value violates unique constraint "nombre_moneda_ukey"'
          ) {
            mensaje = "Ya existe una moneda Con ese nombre";
          } else {
            mensaje = error.response.data.message;
          }
        }
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const procesarEliminar = (id) => {
    setActivate(true);

    let endpoint = `${op.conexion}/api/moneda/eliminarmonedas/${id}`;

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setMensaje({
            mostrar: true,
            titulo: "Exito.",
            texto: "Registro Eliminado Correctamente",
            icono: "exito",
          });
          seleccionarRegistros();

          setActivate(false);
        }
      })
      .catch(function (error) {
        let mensaje = "";
        if (error.response === undefined) {
          mensaje = "Error de Conexion";
        } else {
          if (
            error.response.data.message ===
            'duplicate key value violates unique constraint "nombre_moneda_ukey"'
          ) {
            mensaje = "Ya existe una moneda Con ese nombre";
          } else {
            mensaje = error.response.data.message;
          }
        }
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: mensaje,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const handleCloseSi = () => {
    setActivate(false);
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    if (operacion !== 3) {
      procesarRegistro();
    } else {
      procesarEliminar(idmonedadeta);
    }
  };

  const selectDetallesMoneda = (id) => {
    let anio = moment(fechaSistema).format("YYYY");
    let ms = moment(fechaSistema).format("MM");

    let endpoint = `${op.conexion}/api/consulta/seleccionarmonedadetalle?id=${id}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setRecords(response.data);
          seleccionarMesMoneda(ms, id, anio);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const onChange = (e) => {
    if (e.target.name === "nombre") {
      e.target.value = e.target.value.toUpperCase();
    }

    if (e.target.name === "moneda") {
      selectDetallesMoneda(e.target.value);
    }

    if (e.target.name === "mes") {
      let m = e.target.value;
      let val = txtLogo.current.value;
      let a = moment(fechaSistema).format("YYYY");
      seleccionarMesMoneda(m, val, a);
      setValor([]);
      setLabel([]);
      setMenor([]);
      setTotal(0.0);
    } else if (e.target.name === "logo") {
      let val = txtLogo.current.value;
      txtMoneda.current.value = "";
      setValor([]);
      setLabel([]);
      setMenor([]);
      if (val > 0) {
        setBloqueado(false);
        setTotal(0.0);
        txtMoneda.current.focus();
      } else {
        setBloqueado(true);
      }
    }
  };

  const onSimbolo = (e) => () => {
    setIdm(e);
  };

  const onCerrar = () => {
    setCatalogo(false);
    seleccionarRegistrosm();
  };

  const seleccionarRegistros = () => {
    let a = moment(fechaSistema).format("YYYY");

    let endpoint = `${op.conexion}/api/moneda/seleccionarmonedas`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setTipo(response.data);
          seleccionarMonedaCal(a);

          const idmonedaa = [];
          const results = [];
          const element = [];
          const unicos = [];
          const color = [];

          if (response.data.length > 0) {
            for (let i = 0; i < response.data.length; i++) {
              idmonedaa.push(response.data[i]);
            }

            for (var i = 0; i < idmonedaa.length; i++) {
              const elemento = idmonedaa[i].descripcion;
              const valor = idmonedaa[i].valor;
              const total = 1;

              if (!unicos.includes(idmonedaa[i].descripcion)) {
                unicos.push(elemento);
                results.push(total);
                color.push(colores[i]);
                element.push({
                  nombre: idmonedaa[i].descripcion,
                  valor: valor,
                  color: colores[i],
                });
              }
            }
            setColorG(color);
            setMonedas(unicos);
            setInfo(results);
            setDatos(element);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      })
      .finally(() => {
        setActivate(false);
      });
  };

  const seleccionarMonedaCal = (a) => {
    let endpoint = `${op.conexion}/api/moneda/tipomoneda?a=${a}`;

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.idmoneda > 0) {
            txtLogo.current.value = response.data.idmoneda;
            let m = response.data.mes.substring(0, 2);
            let id = response.data.idmoneda;
            let a = response.data.mes.substring(3, 7);
            seleccionarMesMoneda(m, id, a);
            setIdm(response.data.simbolo);
            txtMoneda.current.value = parseInt(m);
          }
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarMesMoneda = (m, id, a) => {
    let endpoint = `${
      op.conexion
    }/api/moneda/seleccionarmoneda?m=${m.toString()}&id=${id}&a=${a}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.length > 0) {
            txtMoneda.current.value = moment(response.data[0].fecha).format(
              "MM"
            );
            txtLogo.current.value = response.data[0].idmoneda;
            setBloqueado(false);

            let to = 0;
            let te = 0;
            let contar = 0;
            var label = [];
            var datos = [];

            for (var i = 0; i < response.data.length; i++) {
              contar = contar + 1;
              label.push(moment(response.data[i].fecha).format("DD-MM"));
              datos.push(response.data[i].valor);
            }

            if (contar > 1) {
              to = contar - 2;
              te = contar - 1;
            }

            setValor(datos);
            setLabel(label);

            let porcp = 0.0;
            let totalpcp = 0.0;
            let totalreal = 0.0;

            if (datos[to] > datos[te]) {
              porcp = (datos[to] / datos[te]) * 100;
              totalreal = 100 - porcp;
              totalpcp = formatMoneda(
                totalreal.toString().replace(".", ","),
                ",",
                ".",
                2
              );
              setTotal(totalpcp);
            } else if (datos[to] < datos[te]) {
              porcp = (datos[to] / datos[te]) * 100;
              totalreal = 100 - porcp;
              totalpcp = formatMoneda(
                totalreal.toString().replace(".", ","),
                ",",
                ".",
                2
              );
              setTotal(totalpcp);
            }
          } else {
            setValor([]);
            setLabel([]);
            setMenor(0.0);
            setTotal(0.0);
            setBloqueado(false);
          }
          setActivate(false);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const data = {
    labels: monedas,
    leyend: true,
    datasets: [
      {
        label: "#",
        data: info,
        backgroundColor: colorG,
        borderColor: colorG,
        borderWidth: 1,
        hoverBorderWidth: 15,
      },
    ],
  };

  const options = {
    responsive: true,
    legend: {
      position: "top",
      display: false,
    },
    title: {
      display: true,
      text: `Tipos de Monedas Registradas: ${info.length}`,
    },
  };

  const optionsn = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: "Chart.js Line Chart",
      },
    },
  };

  const datan = {
    labels: label,
    datasets: [
      {
        label: "Variación" + " " + idm,
        data: valor,
        borderColor: "rgba(0, 98, 204)",
      },
    ],
  };

  useEffect(() => {
    seleccionarRegistros();
    seleccionarRegistrosm();
  }, []);

  const gestionar = (data, op) => (event) => {
    event.preventDefault();
    if (op === 3) {
      setIdmonedadeta(data.idmonedadetalle);
      setOperacion(op);
      setFecha(moment(data.fecha).format("YYYY-MM-DD"));
      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: "¡Esta Seguro de Eliminar este Registro!",
        icono: "confirmacion",
      });
    } else if (op === 2) {
      let idmoney = txtCodMoneda.current.value;
      setIdmonedadeta(idmoney);
      setOperacion(op);
      setCatalogo(true);
    }
  };

  const cerrarModal = () => {
    seleccionarRegistrosm();
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
  };

  return (
    <div>
      <div className="col-md-12 mx-auto row m-0">
        <div className="col-md-6 py-1 h-100 row card">
          <div className="col-md-12 mx-auto rounded py-2  border-azul ">
            <div className="row rounded px-0 m-0">
              <div className="colfull col-pd-300 px-3">
                <div className="input-group input-group-sm">
                  <label className="input-group-text" id="inputGroup-sizing-sm">
                    TIPO MONEDA:
                  </label>
                  <select
                    className="form-control form-control-sm form-select fs-6 px-1 fw-bold"
                    ref={txtCodMoneda}
                    name="moneda"
                    onChange={onChange}
                  >
                    {rmoney &&
                      rmoney.map((item, index) => (
                        <option key={index} value={item.idmoneda}>
                          {" "}
                          {`${item.descripcion} ${item.simbolo}`}
                        </option>
                      ))}
                  </select>
                </div>
              </div>

              <div className="col-pd-100 ml-auto d-flex justify-content-end px-3">
                <button
                  ref={btnCatalogo}
                  onClick={gestionar("r", 2)}
                  type="button"
                  className="btn btn-sm mb-2 btn-primary"
                >
                  <i className="fas fa-plus"></i>
                </button>
              </div>
            </div>

            <div className="col-md-12 MT-2" style={{ height: "230px" }}>
              <TblContainer
                container={{
                  height: 230,
                  width: "100%",
                  overflow: "auto",
                  padding: "2px",
                }}
              >
                <TblHead />
                <TableBody className="overflow-hidden table-bordered">
                  {records &&
                    records.map((item, index) => (
                      <TableRow key={index} style={{ padding: "0" }}>
                        <TableCell
                          className="align-baseline bg-light"
                          style={{ textAlign: "center", width: "180px" }}
                        >
                          {moment(item.fecha).format("DD/MM/YYYY")}
                        </TableCell>
                        <TableCell
                          className="align-baseline bg-light"
                          style={{ textAlign: "center", width: "180px" }}
                        >
                          {formatMoneda(
                            item.valor.replace(".", ","),
                            ",",
                            ".",
                            2
                          )}
                        </TableCell>
                        <TableCell
                          className="align-center"
                          style={{ textAlign: "center", width: "50px" }}
                        >
                          <button
                            onClick={gestionar(item, 3)}
                            className="btn btn-sm  btn-danger"
                          >
                            <i className="fa fa-trash"></i>{" "}
                          </button>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </TblContainer>
            </div>
          </div>
        </div>
        <div className="col-md-6 h-100 w-100">
          <div className="col-md-12">
            <TortaMoneda
              data={data}
              height={160}
              options={options}
              datos={datos}
            />
          </div>
          <div>
            <div className="card-body row m-0">
              <div className="col-md-4 row m-0 px-1">
                <div className="row justify-content-center m-0 px-1">
                  <div
                    className="card text-black m-0"
                    style={{ boxShadow: "0px 0px 10px 1px #aaaaaa" }}
                  >
                    <div className="card-img-top">
                      <select
                        ref={txtLogo}
                        name="logo"
                        onChange={onChange}
                        className="form-select form-select-sm border-transparent"
                        aria-label=".form-select-sm example"
                      >
                        {tipo &&
                          tipo.map((item, index) => (
                            <option
                              key={index}
                              value={item.idmoneda}
                              onClick={onSimbolo(item.simbolo)}
                            >
                              {item.simbolo}
                              {"."}
                              {item.descripcion}
                            </option>
                          ))}
                      </select>
                    </div>
                    <div className="text-center">
                      <div className="d-flex justify-content-center">
                        <span>
                          {total.toString().includes("-") ? (
                            <i className="fas fa-arrow-down text-danger me-2" />
                          ) : (
                            <i className="fas fa-arrow-up text-success me-2" />
                          )}
                        </span>
                        <span
                          style={{
                            color: total.toString().includes("-")
                              ? "#F93154"
                              : "#00B74A",
                          }}
                          className="fw-bold"
                        >
                          {total}
                        </span>
                        <span>
                          {total.toString().includes("-") ? (
                            <i className="fas fa-percent text-danger" />
                          ) : (
                            <i className="fas fa-percent text-success" />
                          )}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4 ml-auto">
                <div className="col-md-10 ml-auto mt-3">
                  <select
                    className="form-select form-select-sm"
                    disabled={bloqueado}
                    ref={txtMoneda}
                    name="mes"
                    aria-label=".form-select-sm example"
                    onChange={onChange}
                  >
                    <option value="">Mes</option>
                    <option value={"01"}>Enero</option>
                    <option value={"02"}>Febrero</option>
                    <option value={"03"}>Marzo</option>
                    <option value={"04"}>Abril</option>
                    <option value={"05"}>Mayo</option>
                    <option value={"06"}>Junio</option>
                    <option value={"07"}>Julio</option>
                    <option value={"08"}>Agosto</option>
                    <option value={"09"}>Septiembre</option>
                    <option value={"10"}>Octubre</option>
                    <option value={"11"}>Noviembre</option>
                    <option value={"12"}>Diciembre</option>
                  </select>
                </div>
              </div>
              <div className="col-md-12">
                <Line options={optionsn} height={120} data={datan} />
              </div>
            </div>
          </div>
        </div>
      </div>

      <Dimmer active={activate} inverted>
        <Loader inverted>cargando...</Loader>
      </Dimmer>

      <CatalogoCambiarTasa
        show={catalogo}
        ope={operacion}
        idd={idmonedadeta}
        onHideCancelar={() => onCerrar()}
      />

      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
    </div>
  );
};
export default GestionarMoneda;



// WEBPACK FOOTER //
// ./src/components/configuracionGeneral/gestionDeMonedas.js